export enum LiveClassSubType {
  CLASSIC = 'Classic Instruction',
  CASUAL = 'Casual Conversation',
  PRIVATE = 'Private Classes',
}
